import store from '@/store';

export default class DialerAutoEvent {
  constructor(body) {
    window.console.log(
      '%c [event]',
      'color: #F44336;',
      JSON.stringify(body, null, 4),
    );
    if (!body.activeEvent) {
      if (store.state.channel.channels.voice.status) {
        if (store.state.channel.channels.voice.status == 'processing') {
          store.dispatch('channel/updateStatusVoice', 'available');
        }
      }
    }
  }
}
